<template>
  <!-- my profile screen, shows the data of the logged in user and possible edits -->

  <div
    class="modal fade"
    data-keyboard="false"
    data-backdrop="static"
    id="editMyProfile"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="text-center text-join">Meu perfil</h5>

          <button
            type="button"
            class="close"
            id="closeMyProfile"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="form-signin" autocomplete="off" @submit.prevent="editMyProfile">
            <label for="label-config">Nome</label>
            <div class="input-group mb-2 edit-input">
              <input
                type="text"
                id="nameMyProfile"
                class="form-control input-length"
                v-model="userName"
                disabled
              />
            </div>

            <label for="label-config">Login</label>
            <div class="input-group mb-2 edit-input">
              <input
                type="text"
                id="userLoginMyProfile"
                class="form-control input-length"
                v-model="userLogin"
                disabled
              />
            </div>

            <label for="label-config">Grupo</label>
            <div class="input-group mb-2 edit-input">
              <input
                type="text"
                id="groupMyProfile"
                class="form-control input-length"
                v-model="userGroup"
                disabled
              />
            </div>

            <label for="label-config">Celular</label>
            <div class="input-group mb-2 edit-input">
              <input
                type="text"
                class="form-control"
                v-mask="['55 (##)9####-####']"
                id="celMyProfile"
                v-model="userPhone"
                v-bind:class="{ 'is-invalid': errors.phone }"
                :disabled="!checkedEditPhone"
              />

              <div class="input-group-append">
                <button
                  class="edit-button"
                  type="button"
                  id="editCelMyProfile"
                  v-on:click="checkedEditPhone = true"
                >
                  <em class="fa fa-edit icons"></em>
                </button>
              </div>
            </div>
            <span v-if="errors.phone" class="error">
              <ul>
                <li v-for="msg in errors.phone" :key="msg">{{ msg }}</li>
              </ul>
            </span>

            <label for="label-config">E-mail</label>
            <div class="input-group mb-2 edit-input">
              <input
                type="email"
                id="emailMyProfile"
                class="form-control input-length"
                v-model="userEmail"
                v-bind:class="{ 'is-invalid': errors.email }"
                :disabled="!checkedEditEmail"
                required
              />

              <div v-if="userEditEmail" class="input-group-append">
                <button
                  id="editEmailMyProfile"
                  class="edit-button"
                  type="button"
                  v-on:click="checkedEditEmail = true"
                >
                  <em class="fa fa-edit icons"></em>
                </button>
              </div>
            </div>
            <span v-if="errors.email" class="error">
              <ul>
                <li v-for="msg in errors.email" :key="msg">{{ msg }}</li>
              </ul>
            </span>

            <div class="access-center">
              <button
                class="btn btn-lg access"
                id="sendMyProfile"
                type="submit"
                :disabled="!checkedEditEmail && !checkedEditPhone"
              >
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "MyProfile",
  components: {},
  data() {
    return {
      userName: "",
      userLogin: "",
      userEmail: "",
      userPhone: "",
      userGroup: "",
      userEditEmail: false,
      checkedEditPhone: false,
      checkedEditEmail: false,
      errors: [],
    };
  },
  mounted() {
    let group = localStorage.group;

    axios
      .post(`${process.env.API_PBM}/auth/me`)
      .then((response) => {
        this.userName = response.data.data.usu_nome;
        this.userLogin = response.data.data.usu_login;
        this.userEmail = response.data.data.usu_email;
        this.userPhone = response.data.data.usu_celular;
        this.userEditEmail = response.data.data.vincula_email === '0';
        this.userGroup = group;
      })
      .catch((error) => {
        Vue.$toast.error("Ops! Não foi possível buscar os dados.", {
          position: "top-right",
          duration: 5000,
        });
      });
  },

  methods: {
    editMyProfile: function () {
      let data = {
        email: this.userEmail,
        phone: this.userPhone,
      };
      this.errors = [];
      axios
        .put(`${process.env.API_PBM}/user`, data)
        .then((response) => {
          $("#editMyProfile").modal("hide");

          Vue.$toast.success("Perfil alterado com sucesso!", {
            position: "top-right",
            duration: 5000,
          });
        })

        .catch((error) => {
          this.errors = error.response.data.message;
          Vue.$toast.error("Ops! Confira os campos", {
            position: "top-right",
            duration: 5000,
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-left: 35%;
}
.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

.form-control {
  color: gray;
}

.input-length {
  width: 80%;
  margin: 0 auto;
}

.edit-button {
  background-color: #ced4da;
  height: 100%;
  border: none;
  border-radius: 2px;
}
label {
  display: inline-block;
  font-size: 17px;
  color: rgb(100, 95, 95);
}
.icons {
  font-size: 20px;
  color: rgb(100, 95, 95);
  cursor: pointer;
  width: 100%;
}

.error {
  display: inline-block;
  font-size: 13px;
  color: #b0191a;
  width: 100%;
  margin-left: -20px;
}
.text-align-center {
  margin-top: 5px;
  margin-left: 50px;
  color: rgb(100, 95, 95);
  font-size: 14px;
}

.access {
  color: #fff;
  width: 35%;
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  text-decoration: none;
}
.access-center {
  text-align: center;
}

@media only screen and (max-width: 900px) {
  .text-join {
    color: rgb(100, 95, 95);
    font-size: 20px;
    margin-left: 31%;
  }

  label {
    display: inline-block;
    margin-left: 33px;
    font-size: 17px;
    color: rgb(100, 95, 95);
  }
  .text-align-center {
    margin-top: 5px;
    margin-left: 33px;
    color: rgb(100, 95, 95);
    font-size: 14px;
  }
  .edit-input {
    width: 80%;
    margin-left: 30px;
  }

  .modal {
    padding: 0px !important;
  }
}
@media only screen and (min-width: 960px) {
  /* styles for browsers larger than 960px; */
  .modal-dialog {
    margin-top: 4%;
  }
}
@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
  .modal-dialog {
    margin-top: 7%;
  }
}
@media only screen and (max-device-width: 480px) {
  /* styles for mobile browsers smaller than 480px; (iPhone) */
  .modal-dialog {
    margin-top: 20%;
  }
}
@media only screen and (device-width: 768px) {
  /* default iPad screens */
  .modal-dialog {
    margin-top: 30%;
  }
}

@media only screen and (min-width: 2000px) {
  .modal-dialog {
    margin-top: 12%;
  }
  /* for sumo sized (mac) screens */
}
/* different techniques for iPad screening */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* For portrait layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* For landscape layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/myprofile/MyProfile.vue